import _ from 'lodash';
import React, { ReactNode } from 'react';

import {
  FormLabel,
  SearchableSelectField,
  SelectItemType,
} from '@zapier/common-components';

import MenuItemComponent from './MenuItemComponent';
import SelectionComponent from './SelectionComponent';

type ServiceDropdownProps = {
  autoFocus?: boolean;
  inputId?: string;
  items: Array<SelectItemType>;
  selectedItem: SelectItemType | null | undefined;
  label: ReactNode | Array<ReactNode>;
  labelId: string;
  onChange: (item: SelectItemType) => void;
  placeholder?: string;
  search: (
    query: string,
    services: Array<SelectItemType>
  ) => Array<SelectItemType>;
};

const getKeyForItem = (item: SelectItemType) =>
  item && item.key ? item.key : '';
const getLabelForItem = (item: SelectItemType) =>
  item && item.name ? item.name : '';

/**
 * Renders app picker using zapier-ui SearchableSelectField.
 * SearchableSelectField does most of the work; this component
 * provides custom rendering components for the menu items and
 * the selected item.
 */
const ServiceDropdown = ({
  autoFocus,
  inputId,
  items,
  selectedItem,
  label,
  labelId,
  onChange,
  placeholder = `Search & Select \u2026`,
  search,
}: ServiceDropdownProps) => {
  // Services.search needs to be called with the original unaltered
  // services, otherwise the ordering gets messed up if you pass enhanced
  // services. But we need to pass enhanced services to the ServiceItem
  // component, so that it can disable services, display premium / beta banner, etc.
  const filterItems = (query: string) => search(query, items).slice(0, 25);

  return (
    <div>
      <FormLabel id={labelId}>{label}</FormLabel>
      <SearchableSelectField
        autoComplete="off"
        autoFocus={autoFocus}
        filterItems={filterItems}
        getKeyForItem={getKeyForItem}
        getLabelForItem={getLabelForItem}
        initialSelectedItem={selectedItem}
        inputId={inputId}
        isLoading={_.isEmpty(items)}
        items={items}
        labelId={labelId}
        menuAriaLabel="List of apps"
        MenuItemComponent={MenuItemComponent}
        onChange={onChange}
        placeholder={placeholder}
        SelectionComponent={SelectionComponent}
        shouldSelectOnBlur={false}
      />
    </div>
  );
};

export default ServiceDropdown;
